import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import checkIcon from '../../assets/bullets/check.svg';
import { cprEventEmitter, EVENTS } from './cprEvents';
import { useTranslation } from 'react-i18next';

const IntubationChecklist = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation(['resus']);

  const handleAddSection = (sectionName: string) => {
    cprEventEmitter.emit(EVENTS.ADD_MEDS_SECTION, sectionName);
  };

  return (
    <div className="intubation-accordion">
      <div className="intubation-accordion-container">
        <div
          className="intubation-accordion-header"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className={`intubation-accordion-title rtl ${isExpanded ? 'expanded' : ''}`}>
            <img src={checkIcon} alt="check" />
            {t('intubation.title')}
          </div>
          {isExpanded ? (
            <ChevronUp className="ml-2" size={20} />
          ) : (
            <ChevronDown className="ml-2" size={20} />
          )}
        </div>

        <div className={`intubation-accordion-content ${isExpanded ? 'expanded' : ''}`}>
          <div className="rtl">   
            <div className="space-y-6">
              <section>
                <h4 className="checklist-section-title">{t('intubation.beforeIntubation')}:</h4>
                <ul className="checklist-items">
                  <li>{t('intubation.monitoring')}</li>
                  <li>{t('intubation.preoxygenation')}</li>
                  <li>{t('intubation.suctionConnected')}</li>
                  <li>{t('intubation.roleAssignment')}</li>
                </ul>
              </section>
              <section>
                <h4 className="checklist-section-title">{t('intubation.equipmentPreparation')}:</h4>
                <ul className="checklist-items">
                  <li>{t('intubation.sedationRSIandMuscleRelaxants')}
                    <button 
                      onClick={() => handleAddSection("סדציה, RSI ומשתקי שרירים")}
                      className="btn btn-link"
                      style={{padding: '0px 5px'}}
                    >
                      {t('intubation.showMedications')}
                    </button>
                  </li>
                  <li>{t('intubation.ambuConnected')}</li>
                  <li>{t('intubation.airway')}</li>
                  <li>{t('intubation.laryngoscopeBlade')}</li>
                  <li>{t('intubation.tubesSizes')}</li>
                  <li>{t('intubation.guide')}</li>
                  <li>{t('intubation.lma')}</li>
                  <li>{t('intubation.videoLaryngoscope')}</li>
                  <li>{t('intubation.lidocaineGel')}</li>
                  <li>{t('intubation.bougie')}</li>
                  <li>{t('intubation.etco2Adapter')}</li>
                  <li>{t('intubation.fixationMaterial')}</li>
                  <li>{t('intubation.syringeForCuff')}</li>
                  <li>{t('intubation.ventilatorReady')}</li>
                </ul>
              </section>

              <section>
                <h4 className="checklist-section-title">{t('intubation.afterIntubation')}:</h4>
                <ul className="checklist-items">
                  <li>{t('intubation.connectToEtco2')}</li>
                  <li>{t('intubation.listenToLungs')}</li>
                  <li>{t('intubation.orderChestXray')}</li>
                  <li>{t('intubation.insertNasogastricTube')}</li>            
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntubationChecklist;